"use strict";

(self.webpackChunk_muchmore_turmeric = self.webpackChunk_muchmore_turmeric || []).push([[866], {
  585: (e, t, r) => {
    "use strict";

    r(105);
    var o = r(897),
        n = r(306),
        i = r(99),
        s = r(678),
        a = r(801),
        c = r(779),
        l = r(111);
    let d = null;

    const u = () => {
      window.theme = window.theme || {}, theme.customerTemplates = function () {
        function e() {
          let e = document.getElementById("RecoverHeading"),
              r = document.getElementById("LoginHeading");
          document.getElementById("RecoverPassword").addEventListener("click", function (r) {
            r.preventDefault(), t(), e.setAttribute("tabindex", "-1"), e.focus();
          }), document.getElementById("HideRecoverPasswordLink").addEventListener("click", function (e) {
            e.preventDefault(), document.getElementById("RecoverPasswordForm").classList.add("hide"), document.getElementById("CustomerLoginForm").classList.remove("hide"), r.setAttribute("tabindex", "-1"), r.focus();
          }), e.addEventListener("blur", function () {
            this.removeAttribute("tabindex");
          }), r.addEventListener("blur", function () {
            this.removeAttribute("tabindex");
          });
        }

        function t() {
          let e = document.getElementById("RecoverEmail");
          document.getElementById("RecoverPasswordForm").classList.remove("hide"), document.getElementById("CustomerLoginForm").classList.add("hide"), "true" === e.getAttribute("aria-invalid") && e.focus();
        }

        return {
          init: function () {
            var r, o;
            e(), function () {
              "#recover" === window.location.hash && t.bind(this)();
            }(), function () {
              if (document.querySelector(".reset-password-success")) {
                var e = document.getElementById("ResetSuccess");
                e.classList.remove("hide"), e.focus();
              }
            }(), r = document.getElementById("AddressNewForm"), o = document.getElementById("AddressNewButton"), r && ("undefined" != typeof Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
              hideElement: "AddressProvinceContainerNew"
            }), document.querySelectorAll(".address-country-option").forEach(function (e) {
              var t = e.dataset.formId,
                  r = "AddressCountry_" + t,
                  o = "AddressProvince_" + t,
                  n = "AddressProvinceContainer_" + t;
              new Shopify.CountryProvinceSelector(r, o, {
                hideElement: n
              });
            }), document.querySelectorAll(".address-new-toggle").forEach(function (e) {
              e.addEventListener("click", function () {
                var e = "true" === o.getAttribute("aria-expanded");
                r.classList.toggle("hide"), o.setAttribute("aria-expanded", !e), o.focus();
              });
            }), document.querySelectorAll(".address-edit-toggle").forEach(function (e) {
              e.addEventListener("click", function () {
                var t = e.dataset.formId,
                    r = document.getElementById("EditFormButton_" + t),
                    o = document.getElementById("EditAddress_" + t),
                    n = "true" === r.getAttribute("aria-expanded");
                o.classList.toggle("hide"), r.setAttribute("aria-expanded", !n), r.focus();
              });
            }), document.querySelectorAll(".address-delete").forEach(function (e) {
              e.addEventListener("click", function () {
                var t = e.dataset.formId,
                    r = e.dataset.confirmMessage;
                confirm(r || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
                  parameters: {
                    _method: "delete"
                  }
                });
              });
            }));
          }
        };
      }(), theme.init = function () {
        theme.customerTemplates.init();
      }, document.addEventListener("DOMContentLoaded", theme.init);
    };

    let h,
        y = window.mm_ttc_options,
        m = document.location.href,
        p = "";
    document.querySelector(".myaccount__order-history"), document.querySelector(".myaccount__marketing");
    const f = document.querySelector("#shareable_with_abacus_checkbox"),
          g = document.querySelector("#account-marketing-save-btn"),
          w = document.querySelector(".notifications .close-icon"),
          v = (document.querySelector(".notifications .message"), document.querySelector(".notifications .success")),
          S = document.querySelector(".notifications .warning");

    function q(e) {
      e.style.transition = "height 0.3s ease-out", e.style.height = e.offsetHeight + "px", e.offsetHeight, e.style.height = "0", e.style.overflow = "hidden", setTimeout(() => {
        e.style.display = "none";
      }, 300);
    }

    function L(e) {
      e.style.display = "block";
      const t = e.scrollHeight + "px";
      e.style.transition = "height 0.3s ease-out", e.style.height = "0", e.offsetHeight, e.style.height = t, e.style.overflow = "hidden", setTimeout(() => {
        e.style.height = "", e.style.overflow = "";
      }, 300);
    }

    function b(e) {
      "show" === e ? L(v) : q(v);
    }

    function E() {
      const e = {
        email: y.customer.email,
        tag: p,
        source: "Account"
      };
      fetch("https://hooks.zapier.com/hooks/catch/10704514/biaew6b/", {
        method: "POST",
        body: JSON.stringify(e)
      }).then(e => e.json()).then(e => {
        b("show"), clearTimeout(h), h = setTimeout(() => {
          b("hide");
        }, 5e3);
      }).catch(e => {
        console.error("Error:", e), clearTimeout(h), h = setTimeout(() => {
          "show" === "hide" ? L(S) : q(S);
        }, 5e3);
      });
    }

    const k = () => {
      m.includes("view=marketing") && (p = f.checked ? "NotShareWithAbacus" : "ShareWithAbacus", f.addEventListener("change", function () {
        p = this.checked ? "NotShareWithAbacus" : "ShareWithAbacus";
      }), w.addEventListener("click", function () {
        const e = this.closest(".message");
        e && q(e);
      }), g.addEventListener("click", () => {
        E();
      }));
    };

    var A = r(91);

    const C = () => {
      const e = {
        isSafari: navigator.userAgent.indexOf("Safari") > -1,
        isChrome: navigator.userAgent.indexOf("Chrome") > -1
      },
            t = "https://www.refersion.com/iframe",
            r = "1600",
            o = "100%",
            n = {
        affiliateContainer: document.querySelector(".affiliate-shopify-init"),
        affiliateLink: document.querySelector(".btn-affiliate"),
        isCustomerLoggedIn: document.body.classList.contains("customer-logged-in")
      },
            i = async () => {
        const n = document.querySelector("#refersion-iframe-wrapper");
        if (!n) return !1;
        const i = n.dataset.frameUrl;
        if (!i) return !1;

        try {
          if (!(await fetch(t)).ok) throw new Error("Failed to load iframe content");
          return n.innerHTML = (s = i, e.isSafari && !e.isChrome ? `\n        <p>This browser is not supported, please click the button below to open this frame in a new tab.</p>\n        <input type="button" onclick="window.open('${s}', '_blank');" value="Click here" />\n      ` : `<iframe src="${s}" frameBorder="0" height="${r}" width="${o}"></iframe>`), !0;
        } catch (e) {
          return console.error("Error loading iframe:", e), !1;
        }

        var s;
      },
            s = async () => {
        const {
          affiliateContainer: t,
          isCustomerLoggedIn: r
        } = n;
        if (!r || !t) return;
        const o = `${t.dataset.affiliateUrl}/ssourl/${t.dataset.customerEmail}`;

        try {
          t.innerHTML = "<p>Loading Dashboard...</p>";
          const r = await fetch(o);
          if (!r.ok) throw new Error("Network response was not ok");

          const n = await r.text(),
                s = String(n).replace(/\r?\n|\r|\s/g, ""),
                a = (e => {
            const t = document.createElement("div");
            return t.id = "refersion-iframe-wrapper", t.dataset.frameUrl = e, t;
          })(s.replace("www", "theturmericco"));

          t.innerHTML = "", t.appendChild(a), e.isChrome && e.isSafari && (e.isSafari = !1), i();
        } catch (e) {
          t.innerHTML = "<p>Could not obtain affiliate data for your account, please try refreshing the page</p>", console.error("Error loading affiliate dashboard:", e);
        }
      },
            a = () => {
        s(), (async () => {
          const {
            affiliateLink: e,
            isCustomerLoggedIn: t
          } = n;
          if (!t || !e || !e.classList.contains("d-none")) return;
          const r = e.querySelector("a");
          if (!r) return;
          const o = `${r.dataset.affiliateUrl}/isaffiliate`,
                i = r.dataset.customerEmail;
          let s = (0, A.getCookieValue)("isaffiliate");

          const a = t => {
            e.classList.toggle("d-none", !t);
          };

          if (void 0 === s) try {
            const e = await fetch(`${o}/${i}`);
            if (!e.ok) throw new Error("Failed to check affiliate status");
            const t = await e.text();
            s = !!parseInt(String(t).replace(/\r?\n|\r|\s/g, "")), a(s);
            const r = new Date(new Date().setMinutes(new Date().getMinutes() + 1));
            (0, A.setCookie)({
              name: "isaffiliate",
              value: s,
              expires: r
            });
          } catch (e) {
            console.error("Affiliate status check failed:", e);
          } else a(s);
        })();
      };

      "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", a) : a();
    },
          x = document.body;

    const _ = () => {
      const e = document.querySelector(".search");

      if (e) {
        const t = document.querySelectorAll(".search-btn"),
              r = document.querySelector(".close-search-btn");
        document.addEventListener("mouseup", r => {
          e.contains(r.target) || (x.classList.remove("active-search"), t.forEach(e => {
            e.classList.remove("pointer-events-none");
          }), function (e) {
            let t = e.querySelector(".notifications");
            t.querySelector(".error").style.marginTop = "-100%", setTimeout(() => {
              t.style.display = "none";
            }, 600);
          }(e));
        }), r.addEventListener("click", e => {
          x.classList.remove("active-search"), t.forEach(e => {
            e.classList.remove("pointer-events-none");
          });
        }), t.forEach(e => {
          e.addEventListener("click", t => {
            x.classList.remove("active-search"), x.classList.contains("active-search") || (x.classList.add("active-search"), e.classList.add("pointer-events-none"));
          });
        });
      }
    };

    var I = r(615);
    let T,
        B = [],
        D = {},
        M = {},
        P = {},
        $ = {},
        R = {};

    function H() {
      const e = Array.from(document.querySelectorAll('a[data-target]:not([data-target=""])')).map(e => {
        const t = e.dataset.target;
        return {
          link: e,
          selector: t,
          sections: Array.from(document.querySelectorAll(t)),
          active: !1
        };
      });

      function t() {
        const t = function () {
          const t = window.innerHeight / 2;
          let r = null,
              o = 1 / 0;
          return e.forEach(e => {
            e.sections.forEach(n => {
              const i = n.getBoundingClientRect(),
                    s = i.top + i.height / 2,
                    a = Math.abs(s - t);
              i.top < t && i.bottom > t && a < o && (o = a, r = e);
            });
          }), r;
        }();

        e.forEach(e => {
          (null == e ? void 0 : e.selector) === (null == t ? void 0 : t.selector) ? e.link.classList.add("active") : e.link.classList.remove("active");
        });
      }

      window.addEventListener("scroll", (0, l.Z)(() => {
        requestAnimationFrame(t);
      }, 150)), window.addEventListener("resize", (0, I.Z)(() => {
        requestAnimationFrame(t);
      }, 150)), t();
    }

    let O = !1,
        N = 0,
        F = window.scrollY,
        Z = !1;

    function j() {
      const e = window.scrollY,
            t = Math.abs(e - F);
      N += t, F = e, N >= 100 && !Z && (Z = !0, z()), O = !1;
    }

    function W() {
      O || (requestAnimationFrame(j), O = !0);
    }

    function z() {
      M.classList.toggle("-translate-y-full"), T.querySelector("svg").classList.toggle("-rotate-180"), window.removeEventListener("scroll", W), M.classList.contains("-translate-y-full") || (F = window.scrollY, N = 0, Z = !1, window.addEventListener("scroll", W));
    }

    document.body;
    let U = !1,
        K = !1;

    const Y = function () {
      K || (window.requestAnimationFrame(() => {
        const e = window.scrollY;
        e > 100 && !U ? (document.body.classList.add("header-is-sticky"), U = !0) : e < 25 && U && (document.body.classList.remove("header-is-sticky"), U = !1), K = !1;
      }), K = !0);
    };

    const G = () => {
      document.body.classList.add("sticky-header-is-ready"), window.addEventListener("scroll", Y), Y(), document.getElementById("pdp-navbar") && document.body.classList.contains("template-product") && (function () {
        let e = document.querySelector("#pdp-navbar"),
            t = document.querySelector(".pdp-navbar-source-section template");
        e.appendChild(t.content.cloneNode(!0));
      }(), function () {
        let e = document.querySelector(".dropdown-sticky.dropdown .dropdown-menu");
        document.querySelector(".dropdown-page-navbar .dropdown").appendChild(e);
      }(), D = document.querySelector(".sticky-nav-container"), M = document.querySelector(".dropdown-page-navbar"), B = M.querySelectorAll("a.sticky-nav-link"), P = document.querySelectorAll("main .section-wrapper"), $ = {
        offset: 0,
        triggerHook: .1
      }, T = D.querySelector(".sticky-nav-text-wrapper"), R = D.querySelector(".sticky-nav-text"), function (e) {
        if (document.body.classList.contains("sticky-header-is-ready")) return void e();
        const t = new MutationObserver(r => {
          document.body.classList.contains("sticky-header-is-ready") && (t.disconnect(), e());
        });
        t.observe(document.body, {
          attributes: !0,
          attributeFilter: ["class"]
        });
      }(() => {
        !function () {
          const e = P[0];
          let t = window.scrollY,
              r = !1;
          const o = new IntersectionObserver(e => {
            e.forEach(e => {
              const o = window.scrollY,
                    n = o > t;
              e.isIntersecting && n && !r && (document.body.classList.add("is-sticky-nav-active"), r = !0), e.isIntersecting || n || !r || (document.body.classList.remove("is-sticky-nav-active"), r = !1), t = o;
            });
          }, {
            root: null,
            rootMargin: "-96px 0px 0px 0px",
            threshold: 0
          });
          e && o.observe(e), window.addEventListener("DOMContentLoaded", () => {
            e.getBoundingClientRect().top < -96 && (document.body.classList.add("is-sticky-nav-active"), r = !0);
          });
        }(), H(), T.addEventListener("click", z), B.forEach(e => {
          e.addEventListener("click", e => {
            z();
          });
        });
      }));
    };

    function J(e) {
      let t = e.querySelector(".selected-wrapper");
      e.querySelectorAll(".tag-wrapper").length > 0 ? t.classList.remove("hidden") : t.classList.add("hidden");
    }

    function V(e) {
      let t = e.querySelector("button .label"),
          r = e.querySelector("button .loading");
      e.addEventListener("submit", o => {
        o.preventDefault();
        let n = e.querySelector("input#search-input"),
            i = e.querySelectorAll(".tag-wrapper"),
            s = [];

        if (n.value.length > 0 && s.push(n.value), i.forEach(e => {
          let t = e.querySelector(".tag-name").textContent;
          s.push(t);
        }), s.length > 0) {
          t.style.display = "none", r.style.display = "block", function (e) {
            let t = e.querySelector(".notifications");
            t.querySelector(".error").style.marginTop = "-100%", setTimeout(() => {
              t.style.display = "none";
            }, 600);
          }(e);
          let o = "search?q=";
          o += s.join("%20OR%20"), o += "&type=product";
          let n = o.replaceAll(" ", "%20"),
              i = window.mmShopOptions.shop_url + "/";
          window.location.href = i + n;
        } else !function (e) {
          let t = e.querySelector(".notifications"),
              r = t.querySelector(".error");
          t.style.display = "", setTimeout(() => {
            r.style.marginTop = "0%";
          }, 100);
        }(e);
      });
    }

    function X(e, t, r) {
      e.querySelector(".selected-wrapper").appendChild(function (e) {
        let t = document.querySelector("template").content.querySelector(".tag-wrapper").cloneNode(!0);
        return t.setAttribute("data-keyword", e.toLowerCase().replace(" ", "-")), t.querySelector(".tag-name").textContent = e, t;
      }(t)), r.style.display = "none", function (e, t) {
        let r = e.toLowerCase().replace(" ", "-");
        t.querySelector(`.tag-wrapper[data-keyword=${r}]`).querySelector(".remove-tag-btn").addEventListener("click", e => {
          e.target.closest(".tag-wrapper").remove();
          let o = t.querySelector(`.keyword[data-keyword=${r}]`);
          o.style.display = "";
          let n = o.scrollHeight,
              i = o.closest(".accordion-items"),
              s = t.querySelectorAll(".accordion"),
              a = i.previousElementSibling;
          a.classList.contains("active-accordion") || (s.forEach(e => {
            e.classList.remove("active-accordion"), e.nextElementSibling.style.maxHeight = 0;
          }), a.classList.add("active-accordion"));
          let c = parseInt(i.style.maxHeight.replace("px", ""));
          0 === c && (c = i.childNodes[1].scrollHeight), i.style.maxHeight = c + n + "px", J(t);
        });
      }(t, e), J(e);
    }

    const Q = () => {
      let e = document.querySelector("#shopify-section-search .search");

      if (e) {
        let t = e.querySelectorAll(".keyword");
        e.querySelectorAll(".tag-wrapper");
        !function (e) {
          const t = window.location.search,
                r = new URLSearchParams(t);
          let o = e.querySelectorAll(".keyword"),
              n = [];
          o.forEach(e => {
            let t = e.textContent.trim();
            n.push(t);
          }), r.has("q") && r.get("q").split(" OR ").forEach(t => {
            if (n.includes(t)) {
              console.log("includes", t);
              let r = e.querySelector(`.keyword[data-keyword="${t.toLowerCase().replace(" ", "-")}"]`);
              X(e, t, r);
            } else console.log("not iclude", t), function (e, t) {
              e.querySelector("input#search-input").value = t;
            }(e, t);
          });
        }(e), t.forEach(t => {
          t.addEventListener("click", r => {
            let o = t.textContent.trim();
            X(e, o, r.target);
          });
        }), V(e);
      }
    };

    let ee = document.querySelectorAll(".add-to-cart-modal-section");

    function te() {
      ee[0] && ee.forEach(e => {
        e.querySelectorAll(".drawer-item").forEach(e => {
          !function (e) {
            let t = e.querySelector(".add-to-cart-btn");
            t.addEventListener("click", r => {
              r.preventDefault();
              let o = e.querySelectorAll(".single-product"),
                  n = e.querySelector(".discount-code"),
                  i = "checkout",
                  s = {
                items: []
              };
              o.forEach(e => {
                let t = e.querySelector('input[name="variant-id"]'),
                    r = e.querySelector('input[name="selling-plan"]'),
                    o = e.querySelector('input[name="quantity"]');

                if (t) {
                  let e = {
                    id: parseInt(t.value),
                    quantity: parseInt(o.value)
                  };
                  r && (e.selling_plan = parseInt(r.value)), s.items.push(e);
                }
              });
              let a = t.querySelector(".label"),
                  c = t.querySelector(".loading"),
                  l = t.querySelector(".info"),
                  d = t.querySelector(".error");
              a.style.display = "none", c.style.display = "", l.style.display = "", d.style.display = "none", n && (i += `?discount=${n.value}`), console.log(i), async function () {
                await fetch(window.Shopify.routes.root + "cart/clear.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: ""
                }).then(function (e) {
                  return e.json();
                }).catch(function (e) {
                  console.error("Error:", e);
                });
              }().then(e => {
                (async function (e) {
                  return await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify(e)
                  }).then(e => e).catch(e => {
                    console.error("Error:", e);
                  });
                })(s).then(e => {
                  200 === e.status ? window.location.href = window.Shopify.routes.root + i : (a.style.display = "", c.style.display = "none", l.style.display = "none", d.style.display = "");
                });
              });
            });
          }(e);
        });
      });
    }

    n.Z.plugin(o.Z), n.Z.plugin(s.Z), n.Z.plugin(i.Z), n.Z.plugin(a.Z), n.Z.asyncData("cardSlider", () => Promise.all([r.e(660), r.e(440)]).then(r.bind(r, 607))), n.Z.asyncData("embedLoad", () => r.e(807).then(r.bind(r, 583))), window.Alpine = n.Z, n.Z.store("_devtools_stores"), new class {
      constructor() {
        document.querySelectorAll(".yotpo-reviews-section")[0] && (this.$reviewsWrapper = document.querySelectorAll(".yotpo-reviews-section"), this.perPage = 18, this.proxy_uri = "https://theturmeric.co/apps/reviews-widget-proxy", this.app_key = "5jTwhtSmMrw3RGPb4AK1f23q1Kxbx6vEhG2OoJBX", this.url = `${this.proxy_uri}/batch/app_key/${this.app_key}/domain_key/4466362056791/widget/reviews`, this.$reviewsWrapper.forEach(e => {
          let t = 1,
              r = "";
          const o = e.querySelector("#keywords"),
                n = e.querySelector("#reset-filter"),
                i = e.querySelector(".load-more-btn");
          window.addEventListener("beforeKeywordChange", e => {}), o.addEventListener("change", o => {
            this.buildSkeleton(e), t = 1, r = o.target.value, this.buildSkeleton(e), this.fetchData(r, t).then(t => this.processData(t, e)), this.handleResetFilterBtn(r, e);
          }), i.addEventListener("click", o => {
            this.loadMoreBtnLoading(i), this.fetchData(r, t).then(t => this.processData(t, e));
          }), window.addEventListener("afterKeywordChange", e => {
            t++, this.buildGrid(e.detail.data, e.detail.wrapper), this.loadMoreBtnLoaded(i), this.loadMoreBtnVisibility(i, e.detail.data), this.readMoreInit();
          }), n.addEventListener("click", i => {
            this.buildSkeleton(e), t = 1, o.options[0].selected = !0, r = "", this.fetchData(r, t).then(t => this.processData(t, e)), n.style.display = "none";
          }), this.fetchData(r, t).then(t => this.processData(t, e));
        }));
      }

      fetchData() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            t = arguments.length > 1 ? arguments[1] : void 0;
        return window.dispatchEvent(new CustomEvent("beforeKeywordChange")), console.log(e), new Promise(r => {
          let o = e.length > 0 ? "filtered_reviews" : "reviews",
              n = e.length > 0 ? `"free_text_search":"${e}",` : "",
              i = `methods=[{"method":"${o}","params":{"page":${t},"host-widget":"testimonials","is_mobile":false,"pictures_per_review":0,"reference":"testimonials_widget_internal",${n}"hide_custom_fields":true,"per_page":${this.perPage},"type":"testimonials_custom_tab","is_bottomline_summary":false}}]&app_key=${this.app_key}&is_mobile=false&widget_version=2021-09-20_08-30-06`;
          r(fetch(this.url, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: encodeURI(i)
          }));
        }).then(e => e.json()).catch(e => {
          console.error("Reviews - fetchData \n Error:", e);
        });
      }

      processData(e, t) {
        return new Promise((t, r) => {
          t(this.createReviewsObject(e[0].result));
        }).then(e => {
          window.dispatchEvent(new CustomEvent("afterKeywordChange", {
            detail: {
              data: e,
              wrapper: t
            }
          }));
        }).catch(e => {
          console.error("Reviews - processData \n Error:", e);
        });
      }

      createReviewsObject(e) {
        const t = new DOMParser().parseFromString(e, "text/html"),
              r = t.querySelectorAll(".yotpo-review");
        let o = [],
            n = t.querySelector(".yotpo-pager"),
            i = n.querySelectorAll('[role="menuitem"]'),
            s = parseInt(n.querySelector('[aria-current="true"]').textContent);
        return r.forEach(e => {
          o.push({
            name: e.querySelector(".yotpo-user-name") ? e.querySelector(".yotpo-user-name").textContent.trim() : null,
            title: e.querySelector(".content-title") ? e.querySelector(".content-title").textContent.trim() : null,
            content: e.querySelector(".content-review") ? e.querySelector(".content-review").textContent.trim() : null,
            productName: e.querySelector(".grouping-reference-link") ? e.querySelector(".grouping-reference-link").textContent.trim() : null,
            productUrl: e.querySelector(".grouping-reference-link") ? e.querySelector(".grouping-reference-link").href : null,
            rating: e.querySelector(".yotpo-review-stars") ? e.querySelector(".yotpo-review-stars").querySelectorAll(".rating-star").length : null,
            verified: !!e.querySelector(".yotpo-user-title")
          });
        }), {
          reviews: o,
          perPage: parseInt(n.dataset.perPage),
          currentPage: s,
          hasMore: parseInt(i[i.length - 1].dataset.page) > s
        };
      }

      buildSkeleton(e) {
        e.querySelector("#reviews-grid").textContent = "";
        let t = document.querySelector("template#skeleton-card"),
            r = e.querySelector("#reviews-grid");

        for (let e = 0; e < 3; e++) {
          let e = t.content.cloneNode(!0);
          r.append(e);
        }
      }

      buildGrid(e, t) {
        t.querySelectorAll(".skeleton-card").length > 0 && (t.querySelector("#reviews-grid").textContent = "");
        let r = document.querySelector("template#review-card"),
            o = t.querySelector("#reviews-grid");
        e.reviews.forEach(e => {
          let t = r.content.cloneNode(!0);
          t.querySelector(".title").textContent = e.title, t.querySelector(".content").textContent = e.content, t.querySelector(".name").textContent = e.name, t.querySelector(".score-progress").style.width = e.rating / 5 * 100 + "%", e.verified || t.querySelector(".verified").remove(), null === e.productName ? t.querySelector(".reviewed").remove() : t.querySelector(".reviewed-link").textContent = e.productName, o.append(t);
        });
      }

      loadMoreBtnVisibility(e, t) {
        t.hasMore || (e.style.display = "none");
      }

      loadMoreBtnLoading(e) {
        e.querySelector(".label").style.opacity = 0, e.querySelector(".loading").style.opacity = "";
      }

      loadMoreBtnLoaded(e) {
        e.querySelector(".label").style.opacity = "", e.querySelector(".loading").style.opacity = 0;
      }

      handleResetFilterBtn(e, t) {
        let r = t.querySelector("#reset-filter");
        e.length > 0 ? r.style.display = "" : r.style.display = "none";
      }

      handleResize() {
        return (0, l.Z)(() => {
          window.innerWidth < (0, c.cv)("46rem") && (d && d.destroy(), window.removeEventListener("resize", this.handleResize()));
        }, 1e3);
      }

      readMoreInit() {
        d = function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

          const r = document.querySelectorAll(e),
                o = t.collapsedHeight || 170,
                n = t.moreLink || d("Show more"),
                i = t.lessLink || d("Show less"),
                s = t.beforeToggle || function () {},
                a = t.afterToggle || function () {},
                c = [];

          function l(e) {
            if ("string" == typeof e) {
              const t = document.createElement("div");
              return t.innerHTML = e.trim(), t.firstElementChild;
            }

            return e instanceof Element ? e.cloneNode(!0) : d("Toggle");
          }

          function d(e) {
            const t = document.createElement("a");
            return t.href = "#", t.className = "readmore-toggle", t.textContent = e, t;
          }

          return r.forEach(e => {
            const t = e.scrollHeight;
            if (t <= o) return;
            let r = !1;
            e.style.height = `${o}px`, e.style.overflow = "hidden", e.dataset.readmore = "collapsed";

            let d = function c(h) {
              const y = l(h ? i : n);
              return y.addEventListener("click", function (n) {
                n.preventDefault(), s(y, e, r), r = !r, e.dataset.readmore = r ? "expanded" : "collapsed", e.style.height = r ? `${t}px` : `${o}px`;
                const i = c(r);
                y.replaceWith(i), d = i, u.toggleLink = i, a(i, e, r);
              }), y;
            }(r);

            e.after(d);
            const u = {
              el: e,
              toggleLink: d,
              destroy: () => {
                e.style.height = "", e.style.overflow = "", delete e.dataset.readmore, d.remove();
              }
            };
            c.push(u);
          }), {
            destroy() {
              c.forEach(e => e.destroy()), c.length = 0;
            }

          };
        }(".content", {
          collapsedHeight: 170,
          moreLink: '<a href="#" class="more-link text-primary hover:text-primary-dark transition-colors duration-150 inline-block py-2" style="margin: 0 !important;">Show more</a>',
          lessLink: '<a href="#" class="less-link text-primary hover:text-primary-dark transition-colors duration-150 inline-block py-2" style="margin: 0 !important;">Show less</a>',
          beforeToggle: function (e, t, r) {
            let o = t.closest(".review-card");
            o && (o.style.height = "");
          }
        }), window.addEventListener("resize", this.handleResize()), this.handleResize();
      }

    }();
    document.body;
    document.addEventListener("DOMContentLoaded", function () {
      n.Z.start(), G(), (() => {
        const e = document.querySelector(".slideout");

        if (e) {
          const t = document.querySelector(".slideout-btn"),
                r = e.querySelectorAll("li"),
                o = e.querySelectorAll(".back-btn");
          let n = e.querySelector(".top-layer > .layer");
          window.addEventListener("resize", (0, l.Z)(() => {
            window.innerWidth >= (0, c.cv)("80rem") && (x.classList.remove("active-slideout"), t.classList.remove("pointer-events-none"));
          }, 1e3)), document.addEventListener("mouseup", r => {
            e.contains(r.target) || (x.classList.remove("active-slideout"), t.classList.remove("pointer-events-none"), setTimeout(() => {
              n.style.marginLeft = 0;
            }, 500));
          }), t.addEventListener("click", e => {
            x.classList.remove("active-search"), x.classList.contains("active-slideout") || (x.classList.add("active-slideout"), t.classList.add("pointer-events-none"));
          }), r.forEach(e => {
            e.querySelector("a").addEventListener("click", t => {
              e.classList.contains("has-children") && (t.preventDefault(), n.style.marginLeft = parseInt(n.style.marginLeft) - 100 + "%");
            });
          }), o.forEach(e => {
            e.addEventListener("click", e => {
              e.preventDefault(), n.style.marginLeft = `${parseInt(n.style.marginLeft) + 100}%`;
            });
          });
        }
      })(), Q(), te(), _(), u();
      const e = {
        ".posts-load-on-scroll": () => Promise.all([r.e(660), r.e(898)]).then(r.bind(r, 761)).then(e => e.tagsFilter()),
        ".accordion": () => r.e(209).then(r.bind(r, 924)).then(e => e.accordion()),
        ".instant-add-to-cart": () => Promise.all([r.e(660), r.e(116)]).then(r.bind(r, 329)).then(e => e.instantAddToCart()),
        ".sticky-add-to-card-container": () => r.e(561).then(r.bind(r, 328)).then(e => e.stickyAddToCart2()),
        ".shareon": () => r.e(660).then(r.bind(r, 997)).then(e => e.init()),
        ".testimonial-slider-slides": () => Promise.all([r.e(660), r.e(683)]).then(r.bind(r, 959)).then(e => e.default())
      };
      Object.entries(e).forEach(e => {
        let [t, r] = e;
        document.querySelector(t) && r();
      }), C(), k();
    });
  },
  105: (e, t, r) => {
    r.p = window.__webpack_public_path__;
  },
  779: (e, t, r) => {
    "use strict";

    function o(e) {
      if ("string" != typeof e || !e.endsWith("rem")) return null;
      return 16 * parseFloat(e);
    }

    function n(e) {
      const t = e.getBoundingClientRect();
      return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth);
    }

    r.d(t, {
      cv: () => o,
      v4: () => n
    });
  },
  646: () => {}
}, e => {
  var t = t => e(e.s = t);

  e.O(0, [143, 660], () => (t(585), t(646)));
  e.O();
}]);
